module.exports = __webpack_public_path__ + "cancel_red.6166636b93e7afa0ac2419ab25ebc92a.png";